import { IMeetingArchive } from '../../../resource/meeting-archives/meeting-archives.types';
import { IMeetingSimple } from '../../../resource/meeting-simple/meeting-simple.types';
import * as constants from './meeting-archive.constants';
import * as types from './meeting-archive.types';

export const initialArchivePage = (archiveId: IMeetingArchive['id']): types.IInitialArchivePage => ({
  type: constants.INITIAL_ARCHIVE_PAGE,
  payload: archiveId,
});

export const fetchMeetingArchives = (
  meetingId: IMeetingSimple['id'],
  queryParams: types.IQueryParams,
): types.IFetchMeetingArchives => ({
  type: constants.FETCH_MEETING_ARCHIVE,
  payload: {
    meetingId,
    queryParams,
  },
});

export const storeMeetingArchivesIds = (
  meetingArchivesIds: IMeetingArchive['id'][],
): types.IStoreMeetingArchivesIds => ({
  type: constants.STORE_MEETING_ARCHIVE_IDS,
  payload: meetingArchivesIds,
});

export const storeMeetingArchiveCurrentPage = (currentPage: number): types.IStoreMeetingArchiveCurrentPage => ({
  type: constants.STORE_MEETING_ARCHIVE_CURRENT_PAGE,
  payload: currentPage,
});

export const storeMeetingArchiveTotalPages = (totalPages: number): types.IStoreMeetingArchiveTotalPages => ({
  type: constants.STORE_MEETING_ARCHIVE_TOTAL_PAGES,
  payload: totalPages,
});
